export default __webpack_public_path__ + "static/media/kids-room-reverse.ce63bce7.mp4";